import React, { useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { sellCartProdcut,clearMessage } from "../redux/saleSlice";
import { ToastContainer, toast } from "react-toastify";

const SellProductModal = ({ visible, onCancel, product }) => {
  const dispatch = useDispatch();
  const [pack, setPack] = useState(0);
  const [units, setUnits] = useState(0);
  const [prodcut_price, setProdcut_price] = useState();
  const [manual_price, setManual_price] = useState();
  const [error, setError] = useState(null);
  const { loading,message } = useSelector((state) => state.sales);
  const confirmSellProduct = () => {
    const sellCart = { product_id: product.id, pack, units, manual_price, prodcut_price };
    dispatch(sellCartProdcut(sellCart));
    onCancel();
  };

  useEffect(() => {
    if (message) {
      toast(message);
      setTimeout(() => {
        dispatch(clearMessage());
      }, 3000);
    }
  }, [ dispatch, message]);

  useEffect(() => {
    if (pack > product.packStock) {
      setError(`only ${product.packStock} packs left`);
    } else {
      setError(null);
    }
    setProdcut_price(pack * product.sellingPricePack + units * product.sellingPriceUnit);
  }, [error, product.packStock, pack, units, product.sellingPricePack, product.sellingPriceUnit]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <ToastContainer/>
      <div className="bg-white p-8 rounded-lg w-full max-w-md" onClick={e => e.stopPropagation()}>
        <h2 className="text-lg font-semibold text-center">Sell {product.productName}</h2>
        <p className="text-gray-600 mt-2 text-center">Enter quantity and price</p>
        <p className="text-gray-600 mt-2 text-center">Stock: {product.packStock}.{product.unitStock}</p>

        {/* Quantity Input */}
        <input
          type="number"
          value={pack || ''}
          onChange={(e) => setPack(Number(e.target.value))}
          placeholder="Number of Pack"
          className="border p-3 w-full rounded-full mt-6 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        {error && <p className="text-red-400 text-sm mt-1">{error}</p>}

        <input
          type="number"
          value={units || ''}
          onChange={(e) => setUnits(Number(e.target.value))}
          placeholder="Number of units"
          className="border p-3 w-full rounded-full mt-6 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />

        <input
          type="number"
          value={manual_price || ''}
          onChange={(e) => setManual_price(Number(e.target.value))}
          placeholder="Manual Price"
          className="border p-3 w-full rounded-full mt-6 focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />

        {/* Summary Table */}
        <div className="border-t-2 border-gray-200 w-full my-6 p-4">
          <div className="grid grid-cols-4 gap-4 mb-2 font-semibold text-sm">
            <div>Name</div>
            <div>Quantity</div>
            <div>Total</div>
            <div>Discounted</div>
          </div>
          <div className="grid grid-cols-4 gap-4 text-sm">
            <div>{product.productName}</div>
            <div>{pack}.{units}</div>
            <div>{prodcut_price}</div>
            <div>{manual_price}</div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={onCancel}
            className="px-6 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={confirmSellProduct}
            className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
           {loading?  "..Loading" : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SellProductModal;